import { useEffect } from "react";
import { initialize, SnowplowConfiguration } from "../initialize";

export interface SnowplowTagProps {
  config: SnowplowConfiguration;
  disableAutomaticTracking?: boolean;
}

export function Snowplow({
  config,
  disableAutomaticTracking = false,
}: SnowplowTagProps) {
  useEffect(
    () => initialize({ snowplowConfig: config, disableAutomaticTracking }),
    [config, disableAutomaticTracking]
  );

  return null;
}
